module.exports = __webpack_public_path__ + "img/defaultBg.32c79f75.png";